import React from 'react'
import { useAuth } from '../../hooks/useAuth'

export default function Wannads() {
    const { user } = useAuth();
  return (
    <iframe width="100%" height="800px" border="0" padding="0" margin="0" scrolling="yes" frameborder="0" src={`https://earn.wannads.com/wall?apiKey=658bbdb61ae41422595556&userId=${user.id}`}></iframe>
  )
}
